module.exports = __webpack_public_path__ + "static/media/Jackson St, San Francisco, CA5.31686fc6.jpg";